import styled from "styled-components";

export const StyledMasterRefillingsWrapper = styled.div`
  position: relative;
 
  .master-refilling-head {
    padding: 15px 0 25px;
    display: grid;
    align-items: center;
    grid-template-columns: max-content 175px;
    grid-gap: 20px;
    @media screen and (max-width: 576px) {
      grid-template-columns: 100%;
    }
  }
`;

export const StyledMasterRefillingsDetailsWrapper = styled.div`
  .refiling-details-head {
    padding: 15px 0 25px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    a, button {
      height: 45px;
    }
  }
`;

export const StyledMasterRefillingsDetailsContent = styled.div`
 .refiling-details-content {
  &__block {
   grid-template-columns: 20% 80%;
  }

  &__head {
   padding: 0 25px 20px;
  }

  &__row {
   grid-template-columns: repeat(2, 50%);

   & > div {
    padding: 0;
    margin: 0;

    &:before {
     display: none;
    }

    &:last-child {
     display: inline-flex;

     p {
      width: 100%;
      text-align: left;
      overflow-wrap: break-word;
     }
    }
   }
  }

  .errors {
   color: ${({theme}) => theme.state.error};
  }

  .icon-light-copy {
   cursor: pointer;
  }

  .service {
   display: grid !important;
   grid-template-columns: 100%;
   grid-template-rows: max-content 55px;
   grid-gap: 10px;

   &__icon {
    border: 1px solid ${({theme}) => theme.surface.border};
    background-color: ${({theme}) => theme.surface.background};
    border-radius: 5px;
    margin: 0;
    width: 65px;
    height: 55px;
    grid-area: inherit;
   }
  }

  @media screen and (max-width: 1920px) {
   max-width: inherit;
  }
  
  @media screen and (max-width: 992px) {
   &__block {
    grid-template-columns: 100%;
   }
  }
  
  @media screen and (max-width: 576px) {
   &__row {
    padding: 15px 0;
    grid-template-columns: 100%;

    & > div:first-child {
     padding-bottom: 10px;
     color: ${({theme}) => theme.text.primary};
     font-weight: 600;
    }
   }
  }
 }
`;